import { Injectable } from '@angular/core';
import { ConfigState } from '@digitaix/types';
import { all } from 'deepmerge';

@Injectable({ providedIn: 'root' })
export class ConfigLoaderService<C extends ConfigState = ConfigState> {

  public static files: string[] = ['config.json', 'custom-config.json'];

  public static config: ConfigState | null = null;

  public static async load(): Promise<boolean> {

    const configs = await Promise.all(this.files.map(file =>
      fetch(`/assets/${file}`)
        .then(response => {
          console.log(`load config from '${file}'`);
          return response.json();
        })
        .catch(() => {
          console.warn(`fail to load config from '${file}'`);
          return {};
        })
    ));

    ConfigLoaderService.config = configs.reduce((acc, item) => all([ acc, item ]), {});

    console.log('new app config', ConfigLoaderService.config);

    return true;

  }

  public get config(): C {
    const config = ConfigLoaderService.config;
    if (!config) {
      throw new Error('[ConfigLoaderService] config is not loaded')
    }
    return config as any;
  }

}
